import { Navigate } from "react-router-dom";
import TeacherDashboard from "./teacher_dashboard";
import StudentDashboard from "./student_dashboard";
import { useAuth } from "../context/AuthContext";

const Dashboard = ({ isInstructor }) => {
    const { user } = useAuth();

    if (user?.role?.toLowerCase() === "admin") {
        return <Navigate to="/admin-dashboard" replace />;
    }

    return user?.role === "instructor" ? (
        <TeacherDashboard isInstructor={true} />
    ) : (
        <StudentDashboard isInstructor={false} />
    );
};

export default Dashboard;
